import React from 'react'
import styles from './GrayBackgroundFollows.module.css'

export default function GrayBackgroundFollows() {
  return (
    <section className={styles.GrayBackgroundFollows}/>
  )
}
